<template>
    <div>
      <keep-alive>
          <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"/>
    </div>
    
</template>

<script>
  import './orderCom'
  export default {
    name: 'order'
  }
</script>

<style scoped>

</style>
